import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SheetHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    panelContainer: {
        borderBottomColor: "transparent"
    },
    container: {
        flexDirection: "column",
        flexShrink: 0
    },
    bottomContainer: {
        position: "relative"
    },
    close: {
        position: "absolute"
    }
});

export const useStyles = ({
    controlHeights,
    isShowClose,
    closeStyle,
    isScrolled,
    typography,
    iconSizes,
    borders,
    hitSize,
    colors,
    spaces,
    form
}: SheetHeaderDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        close: {
            top: closeStyle.top,
            end: closeStyle.end
        } as Mutable<ViewStyle>
    };

    if(form === "bottom") {
        styles.close.top = (typography.titleLargeSize.lineHeight - hitSize) / 2;

        styles.close.end = -(hitSize - iconSizes.small) / 2;

        if(isShowClose) {
            styles.container.paddingEnd = hitSize;
        }

        return styles;
    }

    Object.assign(styles.container, {
        paddingEnd: spaces.spacingLg + (isShowClose ? Math.max(controlHeights.small, hitSize) : 0),
        borderBottomWidth: borders.separator,
        paddingBottom: spaces.spacingMd,
        paddingStart: spaces.spacingLg,
        paddingTop: spaces.spacingLg
    });

    if(isScrolled) {
        styles.container.borderBottomColor = colors.content.border.subtle;
    }

    return styles;
};
export default stylesheet;
